module.exports = __webpack_public_path__ + "img/homepage_header.7a6c4894.png";